import { Lightning, Fire, Drop, WifiHigh, Television, Question } from "@phosphor-icons/react";

// Single source of truth for utility type metadata on the frontend — mirrors the backend's
// UTILITY_TYPES/UTILITY_TYPE_LABELS in server.py. Add a new utility type here (and on the
// backend) rather than hard-coding icons/labels in individual pages.
export const UTILITIES = [
    { key: "electricity", label: "Electricity", icon: Lightning, color: "#E5A73C" },
    { key: "piped_gas", label: "Piped Gas", icon: Fire, color: "#FF6B1A" },
    { key: "water", label: "Water", icon: Drop, color: "#5AA0C8" },
    { key: "internet", label: "Internet", icon: WifiHigh, color: "#1F2328" },
    { key: "dth", label: "DTH / Cable", icon: Television, color: "#8B5CF6" },
    { key: "other", label: "Other", icon: Question, color: "#4B5563" },
];
export const UTIL_MAP = Object.fromEntries(UTILITIES.map((u) => [u.key, u]));
